<h1>Geolocalización Transacciones Lote</h1>
<h2 class="text-gray-500">Lote {{ lot }}</h2>

<div *ngIf="!has_data" class="card !bg-yellow-50 mt-8 text-xl font-semibold">
   <fa-icon icon="search-location"></fa-icon>
   No existe data de geolocalización en este lote
</div>

<div *ngIf="has_data" id="map" class="card mt-8" style="height: calc(100vh - 250px)"></div>